module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('request-status', {
    attrs: {
      "request": _vm.req
    }
  }), _vm._v(" "), _c('wiz-layout', {
    attrs: {
      "steps": _vm.steps,
      "initial-step": _vm.step,
      "loading": _vm.req.loading || _vm.settingsReq.loading
    },
    on: {
      "update:initialStep": function($event) {
        _vm.step = $event
      },
      "update:initial-step": function($event) {
        _vm.step = $event
      },
      "close": function($event) {
        return _vm.$emit("close")
      },
      "cancel": function($event) {
        return _vm.$emit("cancel")
      }
    },
    model: {
      value: (_vm.obj),
      callback: function($$v) {
        _vm.obj = $$v
      },
      expression: "obj"
    }
  }, [_c('template', {
    slot: "success"
  }, [_vm._v("\n      This is the success\n    ")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dab4ff1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wizards/Space/index.vue
// module id = 1533
// module chunks = 9